module.exports = __webpack_public_path__ + "img/0-86.84ec2c7b.jpg";